(function () {
  // Require at least local@domain.tld (one @, and a dot in the domain part)
  function isCompleteEmail(value) {
    const s = (value || "").trim();
    if (s === "") return true;
    const at = s.indexOf("@");
    if (at <= 0 || at === s.length - 1) return false;
    const domain = s.slice(at + 1);
    return domain.includes(".") && domain.indexOf(".") < domain.length - 1;
  }

  function initContactForm(section) {
    if (!section || !section.classList.contains("contact-form")) return;

    const form = section.querySelector("form[id^='ContactForm-']");
    if (!form) return;

    const nameHidden = form.querySelector("input[name='contact[name]']");
    const firstInput = form.querySelector("[data-contact-first-name]");
    const lastInput = form.querySelector("[data-contact-last-name]");
    const emailInput = form.querySelector('input[name="contact[email]"]');

    if (!nameHidden || !firstInput || !lastInput) return;

    if (emailInput) {
      const invalidMessage = emailInput.getAttribute("data-email-invalid-message") || "Please enter a complete email address.";
      function validateEmail() {
        const value = emailInput.value || "";
        if (value.trim() === "") {
          emailInput.setCustomValidity("");
          return;
        }
        emailInput.setCustomValidity(isCompleteEmail(value) ? "" : invalidMessage);
      }
      emailInput.addEventListener("input", validateEmail);
      emailInput.addEventListener("blur", validateEmail);
      validateEmail();
    }

    form.addEventListener("submit", function () {
      const first = (firstInput.value || "").trim();
      const last = (lastInput.value || "").trim();
      nameHidden.value = [first, last].filter(Boolean).join(" ");
    });
  }

  function init() {
    document.querySelectorAll(".contact-form[data-section-id]").forEach(initContactForm);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", function (e) {
    if (e.target.querySelector) {
      e.target.querySelectorAll(".contact-form[data-section-id]").forEach(initContactForm);
    }
  });
})();
